import { Component, Input, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RelationshipService } from './relationship.service';
import { Relationship } from './relationship.model';
import { log } from 'util';

@Component({
  selector: 'relationship',
  template: `<form #relationshipForm="ngForm">
              <div class="form-group">
                <label for="relationship">{{ 'relationship.relationshipLabel' | translate }}</label>
                <select class="form-control" id="relationship"
                        [required]="required"
                        [(ngModel)]="relationship" (ngModelChange)="this.relationshipChange.emit($event)" name="relationship">
                  <option value="">{{ 'optionLabel' | translate }}</option>
                  <option *ngFor="let relationship of relationships" [value]="relationship">{{relationship}}</option>
                </select>
              </div>
            </form>`,
})
export class RelationshipComponent {

  @Input() relationships: Array<string> = [];
  @Input() required: boolean = true;
  @Input() relationship: string;
  @Output() relationshipChange = new EventEmitter<string>()
  @ViewChild(NgForm) form;

  constructor() { }
}
